import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { ConfirmationDialog, Typography } from '@statsbomb/kitbag-components';
import { useLocation } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import { userDefaultTeamIdsAtom } from '@/atoms/queries/teams';
import env from '@/env';

export const IQ_DEFAULT_TEAM_PAGE = `https://${env.VITE_IQ_DOMAIN}/personalisation/my-default-team`;

export const DefaultTeamPromptModalBase = ({ defaultTeamId }: { defaultTeamId?: number }) => {
  const { t } = useTranslation('modal');
  const { pathname } = useLocation();
  const [isAcknowledged, setIsAcknowledged] = useState(false);

  const handleConfirm = () => {
    // it's not really necessary to setIsAcknowledged(true) here as we're about to goto IQ (a different site) but
    // doing so isn't wrong, doesn't cause any problems and allows the tests to know we've been through this code
    setIsAcknowledged(true);
    window.location.href = IQ_DEFAULT_TEAM_PAGE;
  };

  // cause the modal to re-open if the user navigates away from settings without setting a default team
  useEffect(() => {
    if (!pathname.includes('/settings')) {
      setIsAcknowledged(false);
    }
  }, [pathname]);

  return (
    !defaultTeamId &&
    !isAcknowledged && (
      <ConfirmationDialog
        id="default-team-prompt"
        title={t('defaultTeamModal.title')}
        isOpen
        onConfirm={handleConfirm}
        confirmLabel={t('defaultTeamModal.confirm')}
      >
        <div className="sm:min-w-[400px] md:min-w-[450px]">
          <Typography variant="bodyRegular">{t('defaultTeamModal.content')}</Typography>
        </div>
      </ConfirmationDialog>
    )
  );
};

export const DefaultTeamPromptModalWithData = () => {
  const defaultTeamId = useAtomValue(userDefaultTeamIdsAtom)?.datahubId;

  return <DefaultTeamPromptModalBase defaultTeamId={defaultTeamId} />;
};

export const DefaultTeamPromptModal = () => (
  <Suspense fallback={null}>
    <DefaultTeamPromptModalWithData />
  </Suspense>
);
